module.exports = __webpack_public_path__ + "assets/img/3c83dd94446de1702ccb7fd2a5fed24f.png";